import React from 'react';
import { HighlightStyled } from './Highlight.styles';
/**
 * @param someProp: what this prop does
 *
 * @returns some description of this component's usage
 */
const Highlight = ({ children, eventHandler = (_) => null, ...props }) => {
    return (React.createElement(HighlightStyled, { ...props }, children));
};
export default Highlight;
//# sourceMappingURL=Highlight.js.map